import React, {Component} from 'react';

// Components
import Button from '../../components/Button/Button';
import Anime from '../../components/Anime/Anime';

class AppTitle extends Component {

    render () {
    
        return (
         
            <div className={ `app-title ${this.props.classes}` }>
                <div className="row">
                    <div className="col-lg-8 col-md-12 col-12">
                    	<Anime type="fade-up" delay="0" duration="4">
                        	<h1>{this.props.data.title}</h1>
                        </Anime>
                        <Anime type="fade-up" delay="1" duration="4">
                        	<h2>{this.props.data.subTitle}</h2>
                        </Anime>
                    </div>
                    <div className="col-lg-4 col-md-12 col-12">
                    	<Anime type="fade" delay="2" duration="4">
	                        <p className="app-title__button">
	                            <Button title="View WordPress Themes" link="/themes" icon="pe-7s-angle-right-circle" classes="big shadow arrow-anim" />                        
	                        </p>
                        </Anime>
                    </div>
                </div>
            </div>

        );
    }
}

export default AppTitle;


// WEBPACK FOOTER //
// ./src/containers/AppTitle/AppTitle.js